// Video library included in theme script enqueue

import "./view.scss";

function buildInlineVideoPlayer(node) {
  if (!node) return;

  const videoId = node.dataset.videoId;
  if (!videoId) return;

  const videoProvider = node.dataset.videoProvider || "vimeo";
  removeInlineVideoIframe(node);

  if (videoProvider === "youtube") {
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(
      videoId
    )}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
    iframe.allow =
      "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share";
    iframe.referrerPolicy = "strict-origin-when-cross-origin";
    iframe.title = "YouTube video";
    iframe.setAttribute("frameborder", "0");
    node.insertBefore(iframe, node.firstChild);

    return { provider: "youtube", iframe };
  }

  // Direct player.vimeo.com iframe avoids oEmbed (404 for some embeddable videos).
  const iframe = document.createElement("iframe");
  iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(
    videoId
  )}?dnt=1`;
  iframe.allow =
    "autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share";
  iframe.referrerPolicy = "strict-origin-when-cross-origin";
  iframe.title = "Vimeo video";
  iframe.setAttribute("frameborder", "0");
  node.insertBefore(iframe, node.firstChild);

  return { provider: "vimeo", instance: new Vimeo.Player(iframe) };
}

function removeInlineVideoIframe(node) {
  if (!node) return;
  const iframe = node.querySelector("iframe");
  if (iframe && iframe.parentNode) {
    iframe.parentNode.removeChild(iframe);
  }
}

function lockBodyScroll() {
  document.body.classList.add("hide-scrollbar", "lightbox-open");
  window.dispatchEvent(new Event("lockLenisScroll"));
}

function unlockBodyScroll() {
  document.body.classList.remove("hide-scrollbar", "lightbox-open");
  window.dispatchEvent(new Event("unlockLenisScroll"));
}

function initLightbox() {
  const containers = document.querySelectorAll(
    ".wp-block-blueprint-video-popup-button"
  );
  if (!containers.length) return;

  for (const container of containers) {
    const playButton = container.querySelector(".open-light-box");
    if (!playButton) continue;

    const lightbox = container.querySelector(".lightbox");
    if (!lightbox) continue;

    const player = lightbox.querySelector(".inline-video-player");
    if (!player) continue;

    const closeButton = player.querySelector(".close-lightbox");
    if (!closeButton) continue;

    let videoPlayer = undefined;

    const column = container.closest(".wp-block-blueprint-column");

    function closeLightboxUi() {
      lightbox.classList.remove("active");
      player.classList.remove("ready");
      removeInlineVideoIframe(player);
      if (column) column.classList.remove("active-lightbox");
      unlockBodyScroll();
    }

    playButton.addEventListener("click", function () {
      if (!lightbox.classList.contains("active")) {
        lightbox.classList.add("active");
        if (column) column.classList.add("active-lightbox");
        lockBodyScroll();

        videoPlayer = buildInlineVideoPlayer(player);

        if (!videoPlayer) {
          closeLightboxUi();
          return;
        }

        if (videoPlayer.provider === "youtube") {
          // YouTube iframe autoplay starts immediately once inserted.
          player.classList.add("ready");
          return;
        }

        videoPlayer.instance
          .ready()
          .then(function () {
            player.classList.add("ready");
            return videoPlayer.instance.play();
          })
          .catch(function () {
            player.classList.remove("ready");
          });
      }
    });

    closeButton.addEventListener("click", function () {
      if (!lightbox.classList.contains("active")) {
        return;
      }
      if (
        videoPlayer &&
        videoPlayer.provider === "vimeo" &&
        videoPlayer.instance &&
        typeof videoPlayer.instance.destroy === "function"
      ) {
        videoPlayer.instance.destroy().then(closeLightboxUi).catch(closeLightboxUi);
      } else {
        closeLightboxUi();
      }
    });
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initLightbox();
});
